import SettingsList from './settingsList'

export default SettingsList